import { COLORS, TYPOGRAPHY } from '@app/constants';
import { FC, MouseEventHandler } from 'react';
import styled, { CSSProp } from 'styled-components';
import { Notification24 } from '@/b2b/shared/icons';
import { UiButton } from '@/b2b/shared/ui';

interface Props {
  notViewedCount: number;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  buttonCSS?: CSSProp;
}

const NotificationBtnWithCounter: FC<Props> = ({
  notViewedCount,
  onClick,
  buttonCSS,
}) => {
  return (
    <ButtonWrap>
      <StyledIconBtn type="button" onClick={onClick} $CSS={buttonCSS}>
        <Notification24 />
      </StyledIconBtn>
      {notViewedCount ? (
        <NotificationsCounter>
          <span>{notViewedCount}</span>
        </NotificationsCounter>
      ) : null}
    </ButtonWrap>
  );
};

type DefaultCSSProp = { $CSS?: CSSProp };

const StyledIconBtn = styled(UiButton)<DefaultCSSProp>`
  padding: 12px;
  background-color: ${COLORS.grayscale50};
  border-radius: 50%;
  color: ${COLORS.black};

  &:hover {
    background-color: ${COLORS.black50} !important;
    color: ${COLORS.black};
  }
`;

const ButtonWrap = styled.div`
  position: relative;
`;

const NotificationsCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: -4px;
  z-index: 1;
  ${TYPOGRAPHY.disclaimerRegular12};
  color: ${COLORS.white};
  background-color: ${COLORS.secondary300};
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  pointer-events: none;
`;

export default NotificationBtnWithCounter;
